import { PropsWithChildren, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import DropdownCustomized from '~/components/DropdownCustomized';

import {
  cardsFilterSelector,
  EOptions,
  setCardsFilterOption,
} from '~/redux/slices/cardFilters';

import { ReactComponent as MoreVerticalIcon } from '~/assets/images/iconsLibrary/more-vertical.svg';

import styles from './CardsListActionDropdown.module.scss';

interface ICardListActionDropdown {
  className?: string;
}

const mainOptions = [EOptions.SEARCH, EOptions.FILTER, EOptions.SELECT].map(
  (value) => ({
    translation: `CardListView_navigation_${value}`,
    value,
  }),
);

export default function CardsListActionDropdown({
  children,
  className,
}: PropsWithChildren<ICardListActionDropdown>): JSX.Element {
  const dispatch = useDispatch();

  const { option } = useSelector(cardsFilterSelector);

  const setOption = useCallback(
    (value) => {
      dispatch(setCardsFilterOption(value));
    },
    [dispatch],
  );

  return (
    <DropdownCustomized
      className={classNames(styles.moreIcon, className)}
      options={mainOptions}
      onChange={setOption}
      selected={option}
      anchorOriginVertical={60}
      icon={<MoreVerticalIcon />}
    >
      {children}
    </DropdownCustomized>
  );
}
